import HttpClient from '../HttpService';

function createCheckoutSession(planId) {
    return HttpClient.post('/subscriptions/session', { plan: planId });
}

function changePlan(planId) {
    return HttpClient.post('/subscriptions/change-plan', { plan: planId });
}

function getActiveSubscription() {
    return HttpClient.get('/subscriptions/active');
}

function cancelActiveSubscription() {
    return HttpClient.post('/subscriptions/cancel');
}

function reactivateSubscription() {
    return HttpClient.post('/subscriptions/reactivate');
}

function listPaymentMethods() {
    return HttpClient.get('/subscriptions/payment-methods');
}

function createSetupIntent() {
    return HttpClient.post('/subscriptions/setup-intent');
}

function setDefaultPaymentMethod(paymentMethodId) {
    return HttpClient.post(`/subscriptions/payment-methods/${paymentMethodId}/default`);
}

function removePaymentMethod(paymentMethodId) {
    return HttpClient.delete(`/subscriptions/payment-methods/${paymentMethodId}`);
}

function retryPayment() {
    return HttpClient.post('/subscriptions/retry-payment');
}

function listInvoices() {
    return HttpClient.get('/subscriptions/invoices');
}

export default {
    createCheckoutSession,
    changePlan,
    getActiveSubscription,
    cancelActiveSubscription,
    reactivateSubscription,
    listPaymentMethods,
    createSetupIntent,
    setDefaultPaymentMethod,
    removePaymentMethod,
    retryPayment,
    listInvoices
};
